<template>
  <div class="sidebar">
    <SidebarHeader/>
    <SidebarForm/>
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav">
        <template v-for="(item, index) in navItems" :keys="index">
          <template v-if="item.title">
            <template v-if="checkAccessPrivilege(item.module, true)">
              <SidebarNavTitle :name="item.name" :classes="item.class" :wrapper="item.wrapper" :key="index"/>
            </template>
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :classes="item.class" :key="index"/>
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <template v-if="checkAccessPrivilege(item.module)">
                <SidebarNavDropdown :name="item.name" :url="item.url" :icon="item.icon" :key="index">
                  <template v-for="(childL1, indexL1) in item.children" :keys="indexL1">
                    <template v-if="checkAccessPrivilege(childL1.module)">
                      <template v-if="childL1.children">
                        <!-- Second level dropdown -->
                        <SidebarNavDropdown :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :key="indexL1">
                          <li class="nav-item" v-for="(childL2, indexL2) in childL1.children" :key="indexL2">
                            <template v-if="checkAccessPrivilege(childL2.module)">
                              <template v-if="childL2.children">
                                <!-- Third level dropdown -->
                                <SidebarNavDropdown :name="childL2.name" :url="childL2.url" :icon="childL2.icon" :key="indexL2">
                                  <li class="nav-item" v-for="(childL3, indexL3) in childL2.children" :key="indexL3">
                                    <template v-if="checkAccessPrivilege(childL3.module)">
                                      <SidebarNavLink :name="childL3.name" :url="childL3.url" :icon="childL3.icon" :badge="childL3.badge" :variant="item.variant" :key="indexL3"/>      
                                    </template>
                                  </li>
                                </SidebarNavDropdown>
                              </template>
                              <template v-else>
                                <SidebarNavLink :name="childL2.name" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant" :key="indexL2"/>
                              </template>
                            </template>
                          </li>
                        </SidebarNavDropdown>
                      </template>
                      <template v-else>
                        <SidebarNavItem :classes="item.class" :key="indexL1">
                          <SidebarNavLink :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                        </SidebarNavItem>
                      </template>
                    </template>
                  </template>
                </SidebarNavDropdown>
              </template>
            </template>
            <template v-else>
              <template v-if="checkAccessPrivilege(item.module)">
                <SidebarNavItem :classes="item.class" :key="index">
                  <SidebarNavLink :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
                </SidebarNavItem>
              </template>
            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter/>
    <SidebarMinimizer/>
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
export default {
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue